<template>
  <div id="app">
    <div v-if="$root.user" style="padding-bottom: 4rem">
      <b-navbar toggleable="lg" variant="light" type="light">
        <!-- Grands écrans -->
        <!-- Affichage "Accueil" -->
        <b-navbar-nav class="display_none_sm no-border aaaaa ">
          <b-nav-item class="labco_color mr-2"  exact-active-class="active_item"  to="/">
            <img src="./assets/logoLogin.png" class="logo_fix" height="40" />
          </b-nav-item>
        </b-navbar-nav>

        <!-- Petits écrans  -->
        <!-- Affichage d'un logo -->
        <b-navbar-nav class="display_none_lg">
          <b-nav-item
            class="labco_color"
            exact-active-class="active_item"
            to="/"
          >
            <img src="./assets/logoLogin.png" class="mb-2" height="50" />
          </b-nav-item>
        </b-navbar-nav>

        <h6 class="mt-3 user_info_fix labco_color">
          Bienvenue sur votre espace :<br />{{ $root.user.rso }}<br />{{
            $root.user.nom | capitalize
          }}
        </h6>

        <b-navbar-toggle target="nav_collapse" />

        <!-- Résultats -->
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="border-left">
            <b-nav-item
              class="labco_color"
              exact-active-class="active_item"
              to="/Resultats"
            >
              Résultats
            </b-nav-item>
          </b-navbar-nav>

          <!-- Demande -->
          <b-navbar-nav>
            <b-nav-item
              v-if="$root.user.roles.ENREG === 1"
              class="labco_color"
              exact-active-class="active_item"
              to="/Demande/Nouvelle"
            >
              Demandes d'analyses
            </b-nav-item>
          </b-navbar-nav>
          <!-- Affichage grand écran -->
          <!-- Contact -->
          <!-- <b-navbar-nav class="display_none_sm">
            <b-nav-item class=" labco_color" exact-active-class="active_item" to="/Catalogue"> Catalogue et tarifs </b-nav-item>
          </b-navbar-nav> -->
          <!-- Affichage grand écran -->
          <!-- Contact -->
          <!-- <b-navbar-nav class="display_none_sm">
            <b-nav-item class=" labco_color" exact-active-class="active_item" to="/Rapports"> Vos rapports d'essais </b-nav-item>
          </b-navbar-nav> -->
          <!-- Navbar logo de droite -->
          <!-- Affichage grands écrans -->
          <!-- Site internet ; Compte utilisateur ; Déconnexion -->
          <b-navbar-nav class="display_none_sm no-border">
            <a
              v-b-tooltip.hover
              title="Site vitrine"
              href="http://www.laboratoire-labco.com/"
              class="ml-2 mr-2"
              target="blank"
              ><img src="./assets/earthweb.png" class="iconav"
            /></a>
            <!-- <router-link to="/Utilisateur" class="mr-2"><img src="./assets/userico.png" class=" iconav" /></router-link> -->
            <a
              v-b-tooltip.hover
              title="Modification de votre mot de passe"
              href="#"
              class="mr-2"
              v-b-modal.modalUpdatePassword
              ><img src="./assets/userico.png" class="iconav"
            /></a>
            <a
              v-b-tooltip.hover
              title="Se déconnecter"
              href="#"
              @click="disconnect"
              ><img src="./assets/logoutico.png" class="iconav"
            /></a>
          </b-navbar-nav>
          <!-- Affichage petits écran -->
          <!-- Compte utilisateur  -->
          <!-- <b-navbar-nav class="ml-auto display_none_lg">
            <b-nav-item class=" labco_color" exact-active-class="active_item" to="/Catalogue"> Catalogue et tarifs </b-nav-item>
          </b-navbar-nav> -->
          <!-- Affichage petits écran -->
          <!-- Compte utilisateur  -->
          <!-- <b-navbar-nav class="ml-auto display_none_lg">
            <b-nav-item class=" labco_color" exact-active-class="active_item" to="/Rapports">Vos rapports d'essais </b-nav-item>
          </b-navbar-nav> -->
          <!-- Contact -->
          <!-- <b-navbar-nav class="ml-auto display_none_lg">
            <b-nav-item class=" labco_color" exact-active-class="active_item" to="/Utilisateur"> Compte Utilisateur </b-nav-item>
          </b-navbar-nav> -->
          <!-- Déconnexion -->
          <b-navbar-nav class="ml-auto display_none_lg">
            <b-nav-item class="labco_color" @click="disconnect">
              Déconnexion
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <router-view></router-view>

      <b-navbar variant="light" type="light" fixed="bottom" style="height: 1rem; min-width: 300px; padding: 2rem;" >
        <ul class="navbar-nav border-left">
          <li class="nav-item labco_color">
            <a class="nav-link" target="blank" href="https://alco.info/doc/Procedure_Gestion_Reclamations.pdf">Procédure de Gestion de Réclamation</a>
          </li>
          <li class="nav-item border-left labco_color">
            <a class="nav-link" target="blank" href="https://alco.info/doc/Catalogue_analytique.pdf">Catalogue analytique</a>
          </li>
          <li class="nav-item border-left labco_color">
            <a class="nav-link" target="blank" href="https://alco.info/doc/preparation_des_fromages.pdf">Préparation des fromages</a>
          </li>
        </ul>
      </b-navbar>
      <modal-update-password v-model="$root.user"></modal-update-password>
    </div>
    <b-container class="form_login" v-else>
      <div class="imgLog"><img src="./assets/logoLogin.png" /></div>
      <b-row>
        <b-col class="padding_0">
          <img class="barreLog" src="./assets/barreLogin.png" />
          <b-card class="login_card">
            <h1>
              Avec l'application du LABCO <br />
              consultez et créez vos demandes <br />
              d'analyses.
            </h1>
            <auth></auth>
            <div  v-if="showMaintenanceMessage" class="alert alert-warning alert-dismissible fade show mt-5" style="max-width: 500px; margin: 0 auto;" role="alert">
                <h5 class="alert-heading">⚠️ Maintenance programmée</h5>
                <p><strong>Chers clients,</strong><br>
                Nous vous informons que nos sites internet seront temporairement indisponibles en raison d'une opération de maintenance programmée le <strong>jeudi 7 août 2025, de 09h00 à 12h00</strong>.</p>
                <hr>
                <p class="mb-0">Cette intervention vise à améliorer la qualité et la sécurité de nos services. Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée et vous remercions de votre compréhension.<br><br>
                <em>Cordialement, L'équipe informatique ALCO</em></p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import Auth from './components/Auth/Auth.vue'
import ModalUpdatePassword from './components/Auth/ModalUpdatePassword.vue'

export default {
  name: 'app',
  data () {
    return {
    }
  },
  computed: {
    showMaintenanceMessage () {
      const today = new Date()
      const maintenanceDate = new Date('2025-08-07') // 7 août 2025

      // Afficher seulement avant ou le jour de la maintenance
      return today <= maintenanceDate
    }
  },
  methods: {
    disconnect: function () {
      const vm = this

      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')

      vm.$root.user = null
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      let stringArray = value.split(' ')
      let complete = ''
      stringArray.forEach(word => {
        word = word.toString()
        complete += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' '
      })
      return complete
    }
  },
  components: {
    Auth,
    ModalUpdatePassword
  }
}
</script>

<style>
body,
html {
  background-color: white;
}

.login_card input {
  border: none;
  background-color: white !important;
  box-shadow: 1px 1px 10px black;
  background-position: right;
  background-size: 1.8vw;
}

.font_size_0_7 {
  font-size: 0.7rem !important;
}

.font_size_0_9 {
  font-size: 0.9rem !important;
}

.form_login .row {
  width: 65%;
}

.logo_fix {
  position: relative;
  z-index: 2;
}

.user_info_fix {
  background: #f7931e;
  padding: 1%;
}

.login_card h1 {
  text-align: center;
}

.login_card,
.login_card h1,
.login_card .btn-link {
  color: #ffffff;
}

.login_card .col-form-label {
  font-size: 1rem;
}

.login_card {
  margin: auto;
  background-color: #53a3ab;
  border-left: solid white;
  height: 50vw;
}

.card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

h1 {
  color: white;
  padding-bottom: 3vw;
}

.btn {
  border-radius: 0px 20px 0px 20px;
}

.btn-success,
.btn-success.disabled,
.btn-success:disabled {
  background-color: #f7931e;
  border-color: #2083bc;
}

.btn-success:hover, .btn-success:focus {
  background-color: #d8801b;
  border-color: #1a6c9c;
  box-shadow: 0 0 0 0.2rem rgb(216 128 27 / 50%);
}

.btn-link.focus,
.btn-link:focus {
  box-shadow: none;
}

.nav-link {
  font-weight: bold;
}

.login_card input:focus {
  color: #2083bc;
  background-color: #ffffff;
  border-bottom: none;
  outline: 0;
  box-shadow: 1px 1px 5px #89c338;
}

.mb-7 {
  margin-bottom: 7rem;
}

.useClient {
  background: #f7931e;
}

.error_msg {
  height: 15px;
  font-size: 1.2em;
  color: #6e2b0d;
}

.form_login {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.8em;
}

.labco_color a {
  color: white !important;
}

.labco_color {
  color: white !important;
}

.navbar {
  background-color: #509eb3 !important;
  /* border-bottom: #2083C2 1px solid; */
}

.navbar-brand a {
  color: black;
}

.dropdown-item.active {
  background-color: #24509e !important;
}

.dropdown-item:active {
  background-color: #ffffff !important;
  border: #2083c2 1px solid;
}

.dropdown-item:hover {
  background-color: #509eb3 !important;
  border: none;
}

.dropdown-menu {
  background: #509eb3 !important;
}

.iconav {
  width: 1.5vw;
}

.navbar {
  padding-bottom: 0;
}

.form_login .forgetpassword {
  text-align: right;
}

.form_login .btn-connexion {
  width: 35%;
  box-shadow: 1px 1px 20px black;
  font-size: 1.3vw;
}

.form_login .form-row {
  justify-content: center;
}

.form_login .btn-login > div {
  display: flex;
  justify-content: center;
}

.display_none_lg {
  display: none;
}

.barreLog {
  position: absolute;
  z-index: 3;
  margin-left: 1vw;
  height: 50vw;
}

.imgLog {
  margin-right: 8vw;
}

.imgLog img {
  width: 18vw;

}

.contains {
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 1200px) {
  .form_login {
    max-width: 100%;
  }
  .navbar {
    height: 3vw;
  }
}

@media (min-width: 992px) {
  .active_item {
    margin-bottom: -1px;
  }

  .bg-light {
    border-bottom: #2083c2 1px solid;
  }
  .navbar-nav {
    border-right: solid white 1px;
  }
  .navbar {
    height: 5vw;
  }
  .border-left {
    border-left: solid white 1px !important;
  }
  .no-border {
    border: none;
  }
  .form_login {
    padding-right: 0px !important;
  }
  .form_login .padding_0 {
    padding-right: 0px !important;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .form_login {
    max-width: 1151px !important;
  }
}

@media (min-width: 992px) {
  .user_info_fix {
    position: absolute;
    right: 0;
    margin-right: 1rem;
  }
}

@media (max-width: 991px) {
  .login_card {
    height: 74vh;
    width: 100vw;
  }

  .padding_0 {
    padding: 0 !important;
  }

  .logo_form {
    width: 93vw !important;
  }

  .display_none_sm {
    display: none;
  }

  .display_none_lg {
    display: inline;
  }

  .form_login {
    flex-direction: column;
    max-width: 100% !important;
    padding-left: 0px;
  }

  .form_login .row {
    width: 100%;
  }

  .barreLog {
    display: none;
  }

  .imgLog {
    margin-right: 0vw;
    text-align: center;
    padding-top: 5%;
    padding-bottom: 5%;
  }
  .imgLog img {
    width: 20%;
  }
  .form_login .btn-success {
    font-size: 2.3vw;
  }

  .form_login h1 {
    font-size: 6vw;
  }

  .form_login .form-row {
    justify-content: flex-start;
  }

  .form_login .col-6 {
    flex: 100%;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue